// removed by extract-text-webpack-plugin
module.exports = {"page-Profile__main":"_1Tu9pkFFUHY8ivQXer5_hY","page-Profile__lessons":"_3TgZPeYK0HHwvvcmY9SgFY","page-Profile__section-heading":"pZxOTFZ06-9CzxeDl1bYX","lecture-group":"VQ6Aaj6S6CB1B_VGNIAYE","lecture-item":"ACX9q7rzpZz9TeEVb4h84"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/AccountPage/account-page.scss
// module id = 1196
// module chunks = 0